<template>
  <div class="google-popup">
    <el-dialog
      :title="'谷歌验证器'"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <div class="ew-code" v-if="QRcode">
        <el-image :src="QRcode" :width="'150px'" :height="'150px'" />
      </div>
      <span v-else>提示：请输入第一次登陆，绑定的谷歌验证器动态验证码</span>
      <el-input
        tabindex="11"
        v-model="params.otp"
        placeholder="请输入验证码"
        @keyup.native.enter="login()"
        size="small"
        ref="opt_oninput"
      ></el-input>
      <el-button
        style="margin-left: 20px"
        @click="login()"
        type="success"
        size="small"
        >确定</el-button
      >
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      input: '',
      dialogVisible: false,
      QRcode: '',
      params: {
        name: '',
        otp: ''
      }
    }
  },
  methods: {
    login() {
      let params = Object.assign({}, this.params)
      API.verify(params).then(res => {
        if (res.code === 200) {
          this.$emit('handleVerify', res.data)
          this.handleClose()
        } else {
          this.$message.error('验证码错误，请重新验证')
          this.params.otp = ''
        }
      }).catch(err => {
        this.$message.error(err)
        this.form.passWord = ''
      })
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params.otp = ''
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.opt_oninput.focus();
      })
      this.params.name = row.name
      this.QRcode = row.QRcode
    }
  }

}
</script>

<style lang="scss">
.google-popup {
  text-align: center;
  .ew-code {
    width: 150px;
    height: 150px;
    background: red;
    margin: 0 auto;
  }
  .el-input {
    margin-top: 20px;
    width: 150px;
  }
}
</style>


